<template>
    <div class="page-header">
        <div class="content">
            <div class="title">{{ title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageHeader",

    props: {
        title: String,
    },
}
</script>

<style scoped>

</style>
